module.exports = __webpack_public_path__ + "img/face_check.3a2156a9.png";